const BidStatus = {
    active: 0,
    accepted: 1,
    rejected: 2,
    revoked: 3,
};

export default BidStatus;
